// @file Collection of actions related to whiteboard tools.
import { CODE_MODE_TOOL_IDS, VIEWER_TOOL_IDS, WRITER_TOOL_IDS } from '@@/bits/whiteboard_permissions'
import { useWhiteboardStore } from '@@/pinia/whiteboard'
import { useWhiteboardModeStore } from '@@/pinia/whiteboard_mode'
import { useWhiteboardPermissionsStore } from '@@/pinia/whiteboard_permissions'
import { useTldrawEditor } from '@@/vuecomposables/useTldrawEditor'
import { createSharedComposable } from '@vueuse/core'

export const useWhiteboardToolActions = createSharedComposable(() => {
  const whiteboardStore = useWhiteboardStore()
  const whiteboardModeStore = useWhiteboardModeStore()
  const whiteboardPermissionsStore = useWhiteboardPermissionsStore()

  function selectFirstAllowedTool(): void {
    const tldrawEditor = useTldrawEditor().editor
    if (tldrawEditor == null) {
      return
    }

    if (whiteboardModeStore.isCodeMode) {
      tldrawEditor.setCurrentTool(CODE_MODE_TOOL_IDS[0])
      return
    }
    if (whiteboardModeStore.isReadOnlyMode) {
      // Ref: https://linear.app/padlet/issue/PRO-15919/long-term-fix-cannot-change-atoms-during-reaction-cycle
      tldrawEditor.run(() => {
        tldrawEditor.setCurrentTool(VIEWER_TOOL_IDS[0])
      })
      return
    }

    const allowedToolIds = whiteboardPermissionsStore.canIWriteFrame(tldrawEditor.getCurrentPageId())
      ? WRITER_TOOL_IDS
      : VIEWER_TOOL_IDS
    whiteboardStore.selectTool(allowedToolIds[0])
  }

  return {
    selectFirstAllowedTool,
  }
})
